module.exports = __webpack_public_path__ + "img/ic_link_set_default.1ceb3a9a.svg";